<template>
  <Loader v-if="loading" />
  <div v-else>
    <div class="flex content">
      <h1>Scheduled calls by stylist</h1>
      <div class="flex-grow flex text-right"
        style="justify-content: flex-end; align-items: center;">
        <div
          class="margin-right flex">
            <div
              v-show="stylist_id === 'all' || active_tab === 'up_for_grabs'"
              class="flex justify-center align-center bold clickable"
              style="margin-right: 10px; width: 30px;"
              v-on:click="allCountries">All</div>
            <Flag
              v-show="stylist_id === 'all' || active_tab === 'up_for_grabs'"
              v-for="(bool, locale) in selected_countries"
              :localeid="locale"
              :size="32"
              v-bind:key="'flag-' + locale"
              v-on:click="toggleCountry(locale)"
              style="cursor: pointer; margin-right: 10px;"
              :style="bool ? '' : 'filter: grayscale(100%); opacity: 0.5;'" />
        </div>
        <select
          v-if="active_tab != 'up_for_grabs'"
          v-model="stylist_id">
          <option value="all">[ All stylists ]</option>
          <option
            v-for="stylist in getStylists"
            :value="stylist.id"
            :key="stylist.id"
            >{{ stylist.firstname }} {{ stylist.lastname }}</option
          >
        </select>
        <button class="small-margin-left" v-on:click="book_call = true">
          Book call
        </button>
        <button
          :disabled="saving"
          class="small-margin-left"
          v-on:click="processAll">
          Process
        </button>
      </div>
    </div>

    <Loader class="extra-soft" :soft="true" v-if="soft_loading" />

    <Modal v-if="book_call" v-on:close="book_call = false">
      <BookCall v-on:success="book_call = false" />
    </Modal>

    <Modal v-if="comments_editor" v-on:close="comments_editor = false">
      <OrderComments
        :id="comments_editor"
        v-on:success="comments_editor = false"
      />
    </Modal>

    <TransferCall
      v-if="transfer_call"
      :id="transfer_call"
      v-on:success="updated()"
      v-on:close="transfer_call = false"
    />

    <TransferOrderToStylist
      v-if="transferOrderToStylist"
      :id="transferOrderToStylist"
      :customer="transferCustomer"
      v-on:success="updated()"
      v-on:close="transferOrderToStylist = false"
    />

    <RescheduleCall
      v-if="reschedule_call"
      :id="reschedule_call"
      v-on:success="updated()"
      v-on:close="reschedule_call = false"
    />

    <div class="content">
      <Tabs
        :tabs="tabs"
        v-model="active_tab" />
    </div>

    <div
      v-if="active_tab === 'calls'">
      <PreshippingTable
        :columns="scheduled_calls_columns"
        :rows="scheduled_calls"
        tabKeys="calls" />
    </div>
    <div
      :key="'tab-wrapper-' + id"
      v-for="(tab, id) in tabs"
      v-show="active_tab === id && active_tab !== 'calls'">
      <PreshippingTableNew
          :tab="id"
          :ref="'table-' + id"
          :stylist="stylist_id"
          :locales="selected_countries"
          v-if="tabs_reload[id] != null"
          v-on:change-stylist="stylistChanged"
          />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import TransferCall from '@/components/scheduled-calls/Transfer.vue'
import TransferOrderToStylist from '@/components/scheduled-calls/TransferOrderToStylist.vue'
import RescheduleCall from '@/components/scheduled-calls/Reschedule.vue'
import BookCall from '@/components/BookCall.vue'
import OrderComments from '@/components/orders/Comments.vue'
import PreshippingTableNew from '@/components/preshipping/PreshippingTableNew.vue'
import PreshippingTable from "@/components/preshipping/PreshippingTable.vue";

export default {
  data: () => ({
    tabs_reload: {
      calls: null,
      in_progress: null,
      up_for_grabs: null,
      sp: null,
      outstanding: null,
      unknown: null
    },
    book_call: false,
    scheduled_calls: [],
    active_tab: 'in_progress',
    soft_loading: false,
    transfer_call: false,
    transferOrderToStylist: false,
    transferCustomer: false,
    reschedule_call: false,
    loading: false,
    saving: false,
    comments_editor: false,
    stylist_id: 'all',
    filter_country: 1,
    prershipping_filters: {
      filter_preshipping: 1,
      filter_preshipping_10_mins_old: 1,
      filter_preshipping_progress_status: 1
    },
    selected_countries: {
      1: false,
      2: false,
      3: false,
      4: false
    },
    scheduled_calls_columns: {
      call_id: {
        name: 'ID'
      },
      call_at_parsed: {
        name: 'Time'
      },
      customer_name: {
        name: 'Customer'
      },
      size_dress: {
        name: 'Size'
      },
      stylist_name: {
        name: 'Stylist'
      },
      country_id: {
        name: 'From',
        type: 'flag'
      },
      language: {
        name: 'Language'
      },
      customer_comments: {
        name: 'Comment'
      }
    }
  }),
  watch: {
    active_tab () {
      if (this.tabs_reload[this.active_tab] == null) {
        Vue.set(this.tabs_reload, this.active_tab, true)
      }
      if (this.active_tab === 'calls' && this.tabs_reload[this.active_tab]) {
        this.loadCalls()
      }
      if (this.active_tab === 'up_for_grabs') {
        for (var i in this.selected_countries) {
          Vue.set(this.selected_countries, i, false)
        }
        Vue.set(this.selected_countries, this.getStylist.locale_id, true)
      }
    },
    stylist_id (newId) {
      for (var y in this.tabs_reload) {
        Vue.set(this.tabs_reload, y, null)
      }
      setTimeout(() => Vue.set(this.tabs_reload, this.active_tab, true), 100)

      if (this.active_tab === 'calls') {
        this.loadCalls()
      }

      if (newId == 'all' || !newId) {
        for (var i in this.selected_countries) {
          Vue.set(this.selected_countries, i, true)
        }
        return
      }

      var stylist
      for (var s of this.getStylists) {
        if (s.id == newId) {
          stylist = s
        }
      }
      for (var j in this.selected_countries) {
        Vue.set(this.selected_countries, j, stylist.country_id == j)
      }
    }
  },
  computed: {
    ...mapGetters(['getStylist', 'getStylists', 'getCountries']),
    tabs () {
      return {
        calls: {
          name: 'Calls'
        },
        in_progress: {
          name: 'In progress'
        },
        up_for_grabs: {
          name: 'Up for grabs'
        },
        sp: {
          name: 'Sneak Peek'
        },
        outstanding: {
          name: 'Outstanding SPs'
        },
        unknown: {
          name: 'Unknown'
        }
      }
    },
    stylists () {
      return []
    },
    pendingOrders () {
      return this.pending_orders.filter((row) => {
        return row.country === this.filter_country
      })
    },

    countries () {
      return Vue.$array.keyValue(this.getCountries, 'id', 'name')
    },

    getPreshippingRows () {
      return this.preparePreshipping()
    },

    getPreshippingOutstandingRows () {
      return this.preparePreshippingOutstanding()
    }
  },
  components: {
    PreshippingTable,
    TransferCall,
    RescheduleCall,
    BookCall,
    OrderComments,
    TransferOrderToStylist,
    PreshippingTableNew
  },
  methods: {
    updated() {
      this.transfer_call = false
      this.transferOrderToStylist = false
      this.reschedule_call = false

      if (this.active_tab === 'calls') {
        this.loadCalls()
      }
    },
    cancelCall (row) {
      if (confirm('Are you sure?')) {
        Vue.$api.delete(
          '/scheduled-call/' + row.id,
          {},
          {
            before: () => (this.soft_loading = true),
            always: () => (this.soft_loading = false),
            callback: (data) => this.loadCalls()
          }
        )
      }
    },
    loadCalls() {
      const url =
        this.stylist_id === 'all'
          ? '/stylist/scheduled-calls'
          : '/stylist/' + this.stylist_id + '/scheduled-calls'

      Vue.$api.get(
        url,
        {},
        {
          before: () => (this.soft_loading = true),
          always: () => (this.soft_loading = false),
          callback: (data) => {
            this.scheduled_calls = data.scheduled_calls.map((row) => {
              row.call_id = {
                type: 'link',
                url: '/#/scheduled-call/' + row.id,
                title: row.id
              }

              row.customer_name = {
                type: 'customer',
                customer: row.customer
              }

              row.stylist_name = {
                type: 'stylist',
                stylist: row.stylist
              }

              row.language = row.international_call ? 'English' : '-'

              row.country_id = row.customer.locale.country_id

              row.customer_comments = ''
              for (const comment of row.comments) {
                row.customer_comments += comment.value ? comment.value : comment.comment
              }

              row.menu = [
                {
                  name: 'Transfer',
                  onClick: (row) => (this.transfer_call = row.id)
                },
                {
                  name: 'Reschedule',
                  onClick: (row) => (this.reschedule_call = row.id)
                },
                {
                  name: 'Cancel',
                  onClick: (row) => this.cancelCall(row)
                },
                {
                  name: 'Comments',
                  onClick: (row) => this.comments(row)
                }
              ]

              row.options = {
                disabled: !!row.cancelled_at
              }

              if (!row.styling_order_id) {
                row.menu.push({
                  name: 'Pick',
                  onClick: (row) => this.pick(row.order_id)
                })
              }

              if (row.styling_order_id) {
                row.menu.push({
                  name: 'Go to styling',
                  routerLink: '/stylings/process'
                })
              }

              return row
            })
          }
        }
      )
    },
    stylistChanged (data) {
    },
    toggleCountry (locale) {
      for (var i in this.selected_countries) {
        Vue.set(this.selected_countries, i, false)
      }
      Vue.set(
        this.selected_countries,
        locale,
        this.selected_countries[locale] = !this.selected_countries[locale]
      )
    },
    allCountries () {
      for (var i in this.selected_countries) {
        Vue.set(this.selected_countries, i, true)
      }
    },
    processAll () {
      Vue.$api.post(
        '/preshipping/tabs/process-all',
        {},
        {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: data => this.load()
        }
      )
    },
    parse (data) {
      this.records = data
      this.stylist_id = this.getStylist.id
    },
    comments (row) {
      this.comments_editor = row.order_id ? row.order_id : (row.id ? row.id : row.ID)
    }
  },
  created () {
    this.stylist_id = this.getStylist.id
    this.selected_countries[this.getStylist.locale_id] = true
  }
}
</script>
